import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "feedback"]

  copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.value || this.sourceTarget.textContent
    navigator.clipboard.writeText(text).then(() => this.showFeedback())
  }

  showFeedback() {
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.classList.remove("hidden")
    setTimeout(() => this.feedbackTarget.classList.add("hidden"), 1500)
  }
}
